<template>
  <div class="laboratoryManagement">
    <div class="labInfoBox">
      <div class="title" style="text-align: center; padding-top: 32px">
        <div class="text1">实验室信息化管理方案</div>
      </div>
      <div class="labinfos mainBox">
        <div class="labInfoItem">
          <OssImg
            class="labInfoImg"
            src="/UIV3/labInfoIcon.png"
          />
          <div>实验室综合管理平台</div>
        </div>
        <div class="labInfoItem">
          <OssImg
            class="labInfoImg"
            src="/UIV3/labInfoIcon.png"
          />
          <div>化学品全生命周期管理平台</div>
        </div>
        <div class="labInfoItem">
          <OssImg
            class="labInfoImg"
            src="/UIV3/labInfoIcon.png"
          />
          <div>实验室安全检查平台</div>
        </div>
        <div class="labInfoItem">
          <OssImg
            class="labInfoImg"
            src="/UIV3/labInfoIcon.png"
          />
          <div>实验室预约管理</div>
        </div>
        <div class="labInfoItem">
          <OssImg
            class="labInfoImg"
            src="/UIV3/labInfoIcon.png"
          />
          <div>实验室数据上报</div>
        </div>
      </div>
    </div>
    <div class="mainBox">
      <div class="title">
        <div class="text1">方案亮点</div>
      </div>
      <TabLights :list="LIGHTS"></TabLights>
    </div>
    <!-- 方案优势 -->
    <div>
      <div class="advBox homeWrap wow animate__animated animate__fadeIn">
        <div class="title" style="text-align: center; margin-top: 0">
          <div class="text1">方案优势</div>
        </div>
        <div class="mainBox">
          <div class="advList">
            <div class="advItem maria">
              <OssImg
                src="/UIV3/aiIcon.png"
                alt=""
                class="aiIcon"
              />
              <div class="advItemTitle">实验室综合管理</div>
              <div class="advItemText">
                全场景信息拉通管理<br />
                分类分级一体化评定<br />
                多物联设备集中管控<br />
              </div>
            </div>
            <div class="advItem maria">
              <OssImg
                src="/UIV3/aiIcon.png"
                alt=""
                class="aiIcon"
              />
              <div class="advItemTitle">化学品生命周期管理</div>
              <div class="advItemText">
                采购入库全程可追溯<br />
                存储使用合规性监控<br />
                废弃处置规范化管理<br />
              </div>
            </div>
            <div class="advItem maria">
              <OssImg
                src="/UIV3/aiIcon.png"
                alt=""
                class="aiIcon"
              />
              <div class="advItemTitle">实验室安全检查</div>
              <div class="advItemText">
                检查任务智能派发作答<br />
                隐患排查实时记录跟踪<br />
                整改验收闭环化管理<br />
              </div>
            </div>
            <div class="advItem maria">
              <OssImg
                src="/UIV3/aiIcon.png"
                alt=""
                class="aiIcon"
              />
              <div class="advItemTitle">危废处置管理</div>
              <div class="advItemText">
                危废分类规范暂存<br />
                处置申请在线审批<br />
                转移去向全程追踪<br />
              </div>
            </div>
          </div>
          <OssImg
            src="/UIV3/planArrow.png"
            alt=""
            class="advImg"
          />
          <div class="planInfo">
            <span class="infotext">实验室管理</span>
            <span class="infotext">分类分级</span>
            <span class="infotext">化学品申购</span>
            <span class="infotext">危化品库房管控</span>
            <span class="infotext">台账处理</span>
            <span class="infotext">实验室安全</span>
            <span class="infotext">危废处置</span>
            <span class="infotext">环境监测</span>
          </div>
        </div>
      </div>
    </div>
    <section class="mainBox">
      <div class="title">
        <div class="text1">技术壁垒与生态势能</div>
      </div>
      <Advantage :list="TECHNICAL_CAPACITY"></Advantage>
    </section>
  </div>
</template>

<script setup>
import { onMounted, ref } from "vue";
import ManagementPainPoints from "./components/ManagementPainPoints.vue";
import TabLights from "./components/TabLights.vue";
import Advantage from "./components/Advantage.vue";
import { navTo } from "@/utils/util";
import CaseApi from "@/api/caseApi";
import { WOW } from "wowjs";
const caseApi = new CaseApi();

const MANAGE_LIST = ref([
  {
    iconPath: "images/solution/laboratoryManagement/icon1.png",
    title: "安全风险防控被动",
    desc: "人工巡检难覆盖全场景，危化品泄漏、设备过载等隐患难以及时发现，火灾、化学品误食等事故预警滞后",
    key: 0,
  },
  {
    iconPath: "images/solution/laboratoryManagement/icon2.png",
    title: "人员管理漏洞多",
    desc: "实验人员违规操作（如非合规穿戴、单人在岗）缺乏实时监控，安全培训效果难量化，责任界定模糊",
    key: 1,
  },
  {
    iconPath: "images/solution/laboratoryManagement/icon3.png",
    title: "数据孤岛严重",
    desc: "设备运行数据、环境监测数据与管理系统割裂，无法形成联动预警，科研数据价值未被充分挖掘",
    key: 2,
  },
  {
    iconPath: "images/solution/laboratoryManagement/icon4.png",
    title: "分类分级评定繁琐",
    desc: "实验室涉及危化品、设备、实验项目等多维度分类分级评定，评定标准复杂且缺乏统一规范，人工统计分析耗时耗力",
    key: 3,
  },
]);
const LIGHTS = ref([
  {
    tabText: "精准分级管理",
    title: "智能动态评定，精准分级管理",
    desc: "突破传统评定繁琐难题，运用 AI 算法自动分析危化品、设备、实验项目数据，快速完成分类分级，动态更新评定结果，确保风险评估与资源分配精准高效，大幅提升管理效能",
    imgPath: "images/solution/laboratoryManagement/computer1.png",
    key: 0,
  },
  {
    tabText: "全域智能监测",
    title: "全域智能监测，安全主动防控",
    desc: "多传感器与 AI 技术实现全场景覆盖，实时监测人员操作、设备运行、环境参数，对违规行为、异常数据、安全隐患秒级预警，并联动设备自动处置，化被动应对为主动防御，筑牢实验室安全防线",
    imgPath: "images/UIV2/solution2.png",
    key: 1,
  },
  {
    tabText: "数据深度融合",
    title: "数据深度融合，决策科学高效",
    desc: "打破数据孤岛，整合实验室全流程数据，借助大数据分析与可视化技术，生成多维度分析报表与管理看板，为资源调度、采购决策、安全规划等提供科学依据，推动实验室管理向数字化、智能化转型",
    imgPath: "images/UIV2/solution3.png",
    key: 2,
  },
]);

const TECHNICAL_CAPACITY = ref([
  {
    title: "强大物联网平台",
    desc: "高并发、高可靠、弹性扩展的底层支撑",
    imgPath: "images/solution/laboratoryManagement/big_icon1.png",
    key: 0,
  },
  {
    title: "精准可靠的传感器网络",
    desc: "针对实验室严苛环境优化的各类传感器，确保数据准确性",
    imgPath: "images/solution/laboratoryManagement/big_icon2.png",
    key: 1,
  },
  {
    title: "智能边缘计算能力",
    desc: "本地化数据处理与响应，降低延迟，保障核心业务稳定",
    imgPath: "images/solution/laboratoryManagement/big_icon3.png",
    key: 2,
  },
  {
    title: "开放API与系统集成",
    desc: "无缝对接LIMS、ERP等现有实验室管理系统",
    imgPath: "images/solution/laboratoryManagement/big_icon4.png",
    key: 3,
  },
  {
    title: "端到端安全防护",
    desc: "数据传输加密、设备认证、访问控制，保障实验室数据安全",
    imgPath: "images/solution/laboratoryManagement/big_icon5.png",
    key: 4,
  },
  {
    title: "灵活可配置",
    desc: "模块化设计，可根据不同实验室需求快速部署和定制",
    imgPath: "images/solution/laboratoryManagement/big_icon6.png",
    key: 5,
  },
]);

const caseList = ref([]); //案例列表

onMounted(() => {
  const wow = new WOW();
  wow.init();

  getCaseList();
});

/**
 * 获取案例
 */
const getCaseList = async () => {
  const res = await caseApi.getCaseList({});
  //获取前4个数据
  caseList.value = res?.slice(0, 4);
};
</script>

<style lang="scss" scoped>
.labInfoBox {
  width: 100%;
  height: 17.125rem;
  background: url("@/assets/images/bg/labInfoBg.png") no-repeat center;
  background-size: 100% 100%;
  box-sizing: border-box;
  margin-top: 1rem;

  .labinfos {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 1.5rem;

    .labInfoItem {
      width: 20%;
      height: 7.1875rem;
      padding: 1rem 1rem 1rem 2.5rem;
      box-sizing: border-box;
      font-weight: bold;
      font-size: 1rem;
      color: #424242;
      border-right: 1px solid var(--primary-color);
    }

    .labInfoItem:last-child {
      border-right: none;
    }

    .labInfoImg {
      width: 3rem;
      height: 3rem;
      margin-bottom: 1rem;
    }
  }
}

.laboratoryManagement {
  $titleSize: 60px;
  font-family: "PingFang SC";

  .title {
    color: rgba(33, 33, 33, 1);
    font-weight: 500;
    font-size: $titleSize;
    text-align: center;
  }

  main {
    margin: 56px;
  }

  section {
  }

  footer {
    margin-top: 56px;

    .friends {
      margin-top: 32px;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;

      .friendItem {
        width: 24%;
        height: 330px;
        margin-bottom: 32px;
        cursor: pointer;

        .f-img {
          width: 100%;
          height: 220px;

          img {
            width: 100%;
            height: 100%;
            object-fit: contain;

            // &:hover {
            //   transform: scale(1.1);
            //   transition: all 1s ease-in-out;
            // }
          }
        }

        .f-title {
          color: #424242;
          font-size: 16px;
          font-weight: 500;
          margin: 13px 0px;
          padding: 0px 16px;
        }

        .f-desc {
          color: #888888;
          font-weight: 500;
          font-size: 14px;
          padding: 0px 16px;
        }

        .el-card {
          border-radius: 16px;
          height: 330px;

          :deep(.el-card__body) {
            padding: 0px;
          }
        }
      }
    }

    .btn {
      margin: 32px auto 126px;
      width: 97px;
      height: 40px;
      border-radius: 8px;
      background: #32a89e;
      color: #ffffff;
      font-weight: 600;
      font-size: 16px;
      text-align: center;
      line-height: 35px;
      cursor: pointer;
    }
  }
}

.advBox {
  width: 100vw;
  padding: 1rem 0 2rem 0;
  margin-top: 1.5rem;
  background: #deedff url("@/assets/images/bg/planBg.png") no-repeat;

  .advList {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 2.5%;

    .advItem {
      width: 18.75rem;
      height: 12.125rem;
      background: #ffffff;
      box-shadow: 0px 0px 16px 0px rgba(141, 164, 200, 0.4);
      border-radius: 8px 8px 8px 8px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: 1rem;
      box-sizing: border-box;

      .aiIcon {
        width: 3rem;
        height: 3rem;
      }

      .advItemTitle {
        font-weight: bold;
        font-size: 1rem;
        color: #212121;
        margin-bottom: 0.5rem;
        display: flex;
        align-items: center;

        &::before {
          content: "";
          display: inline-block;
          width: 3px;
          height: 16px;
          background: #32a89e;
          border-radius: 99px;
          margin-right: 6px;
          filter: blur(0.3px);
        }
      }

      .advItemText {
        font-weight: 500;
        font-size: 0.875rem;
        color: #888888;
        line-height: 1.3125rem;
        margin-left: 5px;
      }
    }
  }

  .advImg {
    width: 100%;
    height: 100%;
    object-fit: contain;
    padding: 0 9.375rem;
    box-sizing: border-box;
    margin:8px 0 28px 0;
  }

  .planInfo {
    width: 100%;
    height: 119px;
    background: #ffffff;
    box-shadow: 0px 0px 16px 0px rgba(141, 164, 200, 0.4);
    border-radius: 8px 8px 8px 8px;
    display: flex;
    align-items: center;
    justify-content: center;

    .infotext {
      font-weight: bold;
      font-size: 1.25rem;
      color: #424242;
      line-height: 2rem;

      &::after {
        content: "+";
        font-size: 1.5rem;
        color: #32a89e;
        font-weight: bold;
        margin:0 1rem;
        line-height: 2rem;
      }

      &:last-of-type::after {
        content: "";
        margin:0;
      }
    }
  }
}
</style>
